import { render } from "./title.vue?vue&type=template&id=5fbc52ac&scoped=true"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"

import "./title.vue?vue&type=style&index=0&id=5fbc52ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fbc52ac"

export default script